import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
} from "@mui/material";
import React, { useState } from "react";
import { useRefresh, useUnselectAll } from "react-admin";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { ShortTimeEnum } from "../../enums/ShortTimeEnum";
import EventBus from "../../EventBus";
import { OneMealService } from "../../services/OneMealService";
import CkMuiDialog from "./CkMuiDialog/CkMuiDialog";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import CircularLoader from "./CircularLoader";
import ChefForPartyService from "../../services/ChefForPartyService";

interface InputProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  data: any;
  isBulkOperation?: boolean;
  forparty?: boolean;
}

const oneMealService = new OneMealService();
const chefForPartyService = new ChefForPartyService();

const ChangeOmsTimeDialog = (props: InputProps) => {
  const refresh = useRefresh();
  const [timeSelectValue, setTimeSelectValue] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const unselectAll = useUnselectAll("OneMealService");

  const handleClose = () => {
    props.setOpen(false);
    setTimeSelectValue("");
  };

  return (
    <CkMuiDialog
      isDialogOpen={props.open}
      setDialogOpen={props.setOpen}
      onDialogClose={handleClose}
      title={props?.forparty ? "Change Party Time" : "Change OMS Time"}
      secondaryLabel={"Close"}
      secondaryAction={handleClose}
      isLoading={false}
      primaryLabel="Submit"
      primaryAction={async() => {
        if (!timeSelectValue) {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Select the Time to proceed",
            type: CustomSnackbarTypes.WARNING,
          });
        }
        if(!props?.isBulkOperation){
          if(props?.forparty){
            chefForPartyService
            .changeChefForPartyTime(props?.data?.id, { time: timeSelectValue })
            .then(() => {
              refresh();
              handleClose();
          });
            return;
          }
          oneMealService
            .changeOneMealServiceTime(props?.data?.id, { time: timeSelectValue })
            .then(() => {
              refresh();
              handleClose();
          });
        }
          let successCount = 0;
          let failure = 0;

          const changeOmsTime = async () => {
            const promises = props?.data.map(async (element: number) => {
              try {
                setLoading(true);
                const res = await oneMealService.changeOneMealServiceTime(element, { time: timeSelectValue });
                if(res){
                  successCount++;
                }
              } catch (error) {
                failure++;
                console.error(error);
              }
            });

            await Promise.all(promises);
            setLoading(false);
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: `Time Successfully changed for ${successCount} visits and failed for ${failure} visits`,
              type: CustomSnackbarTypes.SUCCESS,
            });
          }
          await changeOmsTime();
          unselectAll();
          refresh();
        }
      }
    >
      <Grid
        container
        spacing={2}
        justifyContent={"space-evenly"}
        style={{ padding: "12px 12px 12px 12px" }}
      >
        {
          loading ? <CircularLoader/> : 
          <Grid item>
          <FormControl style={{ width: "170px", marginTop: "10px" }}>
            <InputLabel id="timeSelect">Time</InputLabel>
            <Select
              labelId="timeSelect"
              id="timeSelect"
              label="Time"
              value={timeSelectValue}
              onChange={(event: SelectChangeEvent) => {
                setTimeSelectValue(event.target.value as string);
              }}
            >
              {Object.values(ShortTimeEnum).map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        }
      </Grid>
    </CkMuiDialog>
  );
};

export default ChangeOmsTimeDialog;
